import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { InputSelect } from '@/components';
import type { FilterState } from '@/features/filterSlice';
import { getRatingOptions } from '@/views/filter/utils';
import { WildfireRiskRating } from '@/features/types';

export const WildfireZoneFilter = (props: {
  control: Control<FilterState>;
}) => {
  const wildfireRatings = getRatingOptions(WildfireRiskRating);
  return (
    <Controller
      control={props.control}
      name="wildfireRatings"
      render={({ field: { onChange, onBlur, value } }) => {
        return (
          <InputSelect
            isMulti
            label="Wildfire zones"
            placeholder="All wildfire zones"
            options={wildfireRatings}
            onChange={onChange}
            onBlur={onBlur}
            value={wildfireRatings.filter((c) => value.includes(c.value))}
            maxMenuHeight={150}
          />
        );
      }}
    />
  );
};
